module.exports = __webpack_public_path__ + "static/img/ico-exerciseOut4.c0f70ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toefl/ico-exerciseOut4.png
// module id = 3ZZj
// module chunks = 96